import React from "react";
import { motion } from "framer-motion";
import GoldButton from "./GoldButton";

const Jumbotron = ({ title, desc, stack, type, image, urls }) => {
    const mandala = require(`../assets/project.svg`);

    const initial = { opacity: 0, translateY: 25 };
    const animate = { opacity: 1, translateY: 0 };
    const transition = { duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96] };
    return (
        <>
            <div className="jumbotron" style={{ background: `url(${mandala})`}}>
                <div className="container">
                    <motion.p
                        initial={initial}
                        animate={animate}
                        transition={{ delay: 0.66, transition }}>
                            <small>{ type }</small>
                    </motion.p>
                    <motion.h1
                        initial={initial}
                        animate={animate}
                        transition={{ delay: 0.33, transition }}>
                            { title }
                    </motion.h1>
                    <motion.div
                        initial={initial}
                        animate={animate}
                        transition={{ delay: 0.66, transition }}>
                            <h2>{ desc }</h2>
                            <div className="tags">
                                {stack.map((item) => {
                                    return (
                                        <p key={item}>{item}</p>
                                    )
                                })}
                            </div>
                            {urls && urls.map((url, i) => {
                                let isGrey = false;
                                if (i > 0) {
                                    isGrey = true;
                                }
                                return <GoldButton text={url.text} link={url.link} inNewTab={true} isGrey={isGrey} key={i} />
                            })}
                    </motion.div>
                </div>
                <div 
                    className="image"
                    style={{ backgroundImage: `url(${image})` }} />
            </div>
        </>
    );
};

export default Jumbotron;